import { render } from "./MoguMoguSTG.vue?vue&type=template&id=2ab3ee53&scoped=true"
import script from "./MoguMoguSTG.vue?vue&type=script&lang=js"
export * from "./MoguMoguSTG.vue?vue&type=script&lang=js"

import "./MoguMoguSTG.vue?vue&type=style&index=0&id=2ab3ee53&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab3ee53"]])

export default __exports__